<section class="about section" id="about">
  <div class="about__content">
    <!-- Description row: [img-left] [text block] [img-right] -->
    <div class="about__description">

      <!-- Left image — alineada con el bloque de texto (Figma) -->
      <div class="about__side-image about__side-image--left">
        <img src="images/about-left.png" alt="Taller creativo Aruma" loading="lazy">
      </div>

      <!-- Imagen superior solo en columna central -->
      <div class="about__center-image">
        <img src="images/about.png" alt="Detalle Aruma" loading="lazy">
      </div>

      <!-- Centro: etiqueta + título + CTA (misma fila que laterales) -->
      <div class="about__text-block">
        <div class="about__label">
          <!-- Sun ornament 42x42 -->
          <svg class="about__ornament" width="42" height="42" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M8.41984 16.0314H1.65515" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M30.3978 16.0314H23.6427" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M10.6459 21.4069L5.86975 26.1927" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M26.1923 5.87012L21.4065 10.6463" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M16.0309 23.6428V30.3979" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M16.0309 1.65515V8.41986" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M21.4065 21.4069L26.1923 26.1927" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M5.86975 5.87012L10.6459 10.6463" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"/>
            <circle cx="15.5" cy="16.2743" r="4" stroke="currentColor"/>
          </svg>
          <span class="about__label-text">Donde la creatividad<br>se encuentra con el bienestar</span>
        </div>

        <h2 class="about__title">
          Aruma es más que un taller creativo. Es un <br>espacio pensado para crear y volver a <br>reconectar contigo a través de la creatividad.
        </h2>

        <button class="btn btn-primary about__cta" (click)="scrollToTalleres()">
          Explorar talleres
        </button>
      </div>

      <div class="about__side-image about__side-image--right">
        <img src="images/about-2.png" alt="Bienestar Aruma" loading="lazy">
      </div>
    </div>

    <!-- Tags row -->
    <div class="about__tags">
      @for (tag of tags; track tag) {
        <span class="tag tag-outline">
          <span class="dot"></span>
          {{ tag }}
        </span>
      }
    </div>
  </div>
</section>
